import { CarType, IODLayerName, ODDataType, ODYearType } from "./IODLayerName";

/** OD量発ゾーン情報_Bゾーン_乗用車レイヤ名 */
const LAYER_OD_STZONE_BZONE_PASSENGER_CAR = "t_od_stzone_bzone_passenger_car";
/** OD量発ゾーン情報_Bゾーン_小型貨物車レイヤ名 */
const LAYER_OD_STZONE_BZONE_SMALL_CARGO = "t_od_stzone_bzone_small_cargo";
/** OD量発ゾーン情報_Bゾーン_普通貨物車レイヤ名 */
const LAYER_OD_STZONE_BZONE_NORMAL_CARGO = "t_od_stzone_bzone_normal_cargo";
/** OD量発ゾーン情報_Bゾーン_車種計レイヤ名 */
const LAYER_OD_STZONE_BZONE_TOTAL = "t_od_stzone_bzone_total";
/** OD量発ゾーン情報_市区町村_乗用車レイヤ名 */
const LAYER_OD_STZONE_CITY_PASSENGER_CAR = "t_od_stzone_city_passenger_car";
/** OD量発ゾーン情報_市区町村_小型貨物車レイヤ名 */
const LAYER_OD_STZONE_CITY_SMALL_CARGO = "t_od_stzone_city_small_cargo";
/** OD量発ゾーン情報_市区町村_普通貨物車レイヤ名 */
const LAYER_OD_STZONE_CITY_NORMAL_CARGO = "t_od_stzone_city_normal_cargo";
/** OD量発ゾーン情報_市区町村_車種計レイヤ名 */
const LAYER_OD_STZONE_CITY_TOTAL = "t_od_stzone_city_total";
/** OD量発ゾーン情報_都道府県_乗用車レイヤ名 */
const LAYER_OD_STZONE_PREF_PASSENGER_CAR = "t_od_stzone_pref_passenger_car";
/** OD量発ゾーン情報_都道府県_小型貨物車レイヤ名 */
const LAYER_OD_STZONE_PREF_SMALL_CARGO = "t_od_stzone_pref_small_cargo";
/** OD量発ゾーン情報_都道府県_普通貨物車レイヤ名 */
const LAYER_OD_STZONE_PREF_NORMAL_CARGO = "t_od_stzone_pref_normal_cargo";
/** OD量発ゾーン情報_都道府県_車種計レイヤ名 */
const LAYER_OD_STZONE_PREF_TOTAL = "t_od_stzone_pref_total";

/** OD量着ゾーン情報_Bゾーン_乗用車レイヤ名 */
const LAYER_OD_ARZONE_BZONE_PASSENGER_CAR = "t_od_arzone_bzone_passenger_car";
/** OD量着ゾーン情報_Bゾーン_小型貨物車レイヤ名 */
const LAYER_OD_ARZONE_BZONE_SMALL_CARGO = "t_od_arzone_bzone_small_cargo";
/** OD量着ゾーン情報_Bゾーン_普通貨物車レイヤ名 */
const LAYER_OD_ARZONE_BZONE_NORMAL_CARGO = "t_od_arzone_bzone_normal_cargo";
/** OD量着ゾーン情報_Bゾーン_車種計レイヤ名 */
const LAYER_OD_ARZONE_BZONE_TOTAL = "t_od_arzone_bzone_total";
/** OD量着ゾーン情報_市区町村_乗用車レイヤ名 */
const LAYER_OD_ARZONE_CITY_PASSENGER_CAR = "t_od_arzone_city_passenger_car";
/** OD量着ゾーン情報_市区町村_小型貨物車レイヤ名 */
const LAYER_OD_ARZONE_CITY_SMALL_CARGO = "t_od_arzone_city_small_cargo";
/** OD量着ゾーン情報_市区町村_普通貨物車レイヤ名 */
const LAYER_OD_ARZONE_CITY_NORMAL_CARGO = "t_od_arzone_city_normal_cargo";
/** OD量着ゾーン情報_市区町村_車種計レイヤ名 */
const LAYER_OD_ARZONE_CITY_TOTAL = "t_od_arzone_city_total";
/** OD量着ゾーン情報_都道府県_乗用車レイヤ名 */
const LAYER_OD_ARZONE_PREF_PASSENGER_CAR = "t_od_arzone_pref_passenger_car";
/** OD量着ゾーン情報_都道府県_小型貨物車レイヤ名 */
const LAYER_OD_ARZONE_PREF_SMALL_CARGO = "t_od_arzone_pref_small_cargo";
/** OD量着ゾーン情報_都道府県_普通貨物車レイヤ名 */
const LAYER_OD_ARZONE_PREF_NORMAL_CARGO = "t_od_arzone_pref_normal_cargo";
/** OD量着ゾーン情報_都道府県_車種計レイヤ名 */
const LAYER_OD_ARZONE_PREF_TOTAL = "t_od_arzone_pref_total";

/**
 * OD量レイヤ指定用クラス
 */
export class ODQuantityLayerName implements IODLayerName {
  /**
   * データ種別
   */
  odDataType: ODDataType;

  /**
   * 車種
   */
  carType: CarType;

  /**
   * 年度
   */
  odYear: ODYearType;

  /**
   * 制限最大値
   */
  odLimitMax: number;

  /**
   * 制限最小値
   */
  odLimitMin: number;

  /**
   * コンストラクタ
   * @param odDataType データ種別
   * @param carType 車種
   * @param odYear 年度
   * @param odLimitMax 制限最大値
   * @param odLimitMin 制限最小値
   */
  constructor(
    odDataType: ODDataType,
    carType: CarType,
    odYear: ODYearType,
    odLimitMax?: number,
    odLimitMin?: number
  ) {
    this.odDataType = odDataType;
    this.carType = carType;
    this.odYear = odYear;
    this.odLimitMax = odLimitMax;
    this.odLimitMin = odLimitMin;
  }

  /**
   * フィルタ条件文字列を取得
   * @param baseCode 拠点コード
   * @param methodName 呼び出し元のメソッド名
   */
  getCqlFilterString(baseCode?: string, methodName?: string): string {
    let cqlParameterString = "";
    if (
      baseCode &&
      (methodName === "getFeatureInfo" || methodName === "onSelectedStartNode")
    ) {
      cqlParameterString = `"発ゾーンコード"='${baseCode}' AND "年度"='${this.odYear}'`;
      if (this.odLimitMax !== null && this.odLimitMin !== null) {
        cqlParameterString =
          cqlParameterString +
          `AND "トリップ数合計値"<=${this.odLimitMax} AND "トリップ数合計値">=${this.odLimitMin}`;
      } else if (this.odLimitMax !== null) {
        cqlParameterString =
          cqlParameterString + `AND "トリップ数合計値"<=${this.odLimitMax}`;
      } else if (this.odLimitMin !== null) {
        cqlParameterString =
          cqlParameterString + `AND "トリップ数合計値">=${this.odLimitMin}`;
      }
    } else if (baseCode && methodName === "getRangeFeatureInfo") {
      cqlParameterString = `"発ゾーンコード"='${baseCode}' AND "年度"='${this.odYear}'`;
    } else {
      cqlParameterString = `"年度"='${this.odYear}'`;
    }
    return cqlParameterString;
  }

  /**
   * レイヤ名を取得
   * @param baseCode 拠点コード
   */
  getLayerName(baseCode?: string): string {
    let layerName = "";
    if (baseCode) {
      if (this.odDataType === "Bゾーン") {
        switch (this.carType) {
          case "乗用車":
            layerName = LAYER_OD_ARZONE_BZONE_PASSENGER_CAR;
            break;
          case "小型貨物車":
            layerName = LAYER_OD_ARZONE_BZONE_SMALL_CARGO;
            break;
          case "普通貨物車":
            layerName = LAYER_OD_ARZONE_BZONE_NORMAL_CARGO;
            break;
          case "車種計":
            layerName = LAYER_OD_ARZONE_BZONE_TOTAL;
            break;
        }
      } else if (this.odDataType === "市区町村") {
        switch (this.carType) {
          case "乗用車":
            layerName = LAYER_OD_ARZONE_CITY_PASSENGER_CAR;
            break;
          case "小型貨物車":
            layerName = LAYER_OD_ARZONE_CITY_SMALL_CARGO;
            break;
          case "普通貨物車":
            layerName = LAYER_OD_ARZONE_CITY_NORMAL_CARGO;
            break;
          case "車種計":
            layerName = LAYER_OD_ARZONE_CITY_TOTAL;
            break;
        }
      } else if (this.odDataType === "都道府県") {
        switch (this.carType) {
          case "乗用車":
            layerName = LAYER_OD_ARZONE_PREF_PASSENGER_CAR;
            break;
          case "小型貨物車":
            layerName = LAYER_OD_ARZONE_PREF_SMALL_CARGO;
            break;
          case "普通貨物車":
            layerName = LAYER_OD_ARZONE_PREF_NORMAL_CARGO;
            break;
          case "車種計":
            layerName = LAYER_OD_ARZONE_PREF_TOTAL;
            break;
        }
      }
    } else {
      if (this.odDataType === "Bゾーン") {
        switch (this.carType) {
          case "乗用車":
            layerName = LAYER_OD_STZONE_BZONE_PASSENGER_CAR;
            break;
          case "小型貨物車":
            layerName = LAYER_OD_STZONE_BZONE_SMALL_CARGO;
            break;
          case "普通貨物車":
            layerName = LAYER_OD_STZONE_BZONE_NORMAL_CARGO;
            break;
          case "車種計":
            layerName = LAYER_OD_STZONE_BZONE_TOTAL;
            break;
        }
      } else if (this.odDataType === "市区町村") {
        switch (this.carType) {
          case "乗用車":
            layerName = LAYER_OD_STZONE_CITY_PASSENGER_CAR;
            break;
          case "小型貨物車":
            layerName = LAYER_OD_STZONE_CITY_SMALL_CARGO;
            break;
          case "普通貨物車":
            layerName = LAYER_OD_STZONE_CITY_NORMAL_CARGO;
            break;
          case "車種計":
            layerName = LAYER_OD_STZONE_CITY_TOTAL;
            break;
        }
      } else if (this.odDataType === "都道府県") {
        switch (this.carType) {
          case "乗用車":
            layerName = LAYER_OD_STZONE_PREF_PASSENGER_CAR;
            break;
          case "小型貨物車":
            layerName = LAYER_OD_STZONE_PREF_SMALL_CARGO;
            break;
          case "普通貨物車":
            layerName = LAYER_OD_STZONE_PREF_NORMAL_CARGO;
            break;
          case "車種計":
            layerName = LAYER_OD_STZONE_PREF_TOTAL;
            break;
        }
      }
    }
    return layerName;
  }
}
